import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {BaseService, Log, Logger} from '@nh/angular-tses';
import {environment} from 'environments/environment';
import {Observable} from 'rxjs';

export interface Feedback {
  summary: string;
  description: string;
  location: string;
  logs: string;
}

@Injectable({
  providedIn: 'root'
})
export class FeedbackService extends BaseService {
  private static readonly FEEDBACK_ENDPOINT: string = `${environment.tsesConfig.apiHost}/feedback`;

  constructor(protected _snackbar: MatSnackBar, private _httpClient: HttpClient) {
    super(_snackbar);
  }

  /**
   * Sends the feedback to the web-service.
   *
   * @param summary     {string}            The feedback summary
   * @param description {string}            The feeback description
   * @param message     {string?}           An optional error message to display in the snackbar
   * @returns           {Promise<number>}   A Promise resolving to the HTTP status code
   */
  public sendFeedback(summary: string, description: string, message?: string): Promise<number> {
    message = message || 'Sorry, could not send feedback. Please try again.';
    const feedback: Feedback = this._buildFeedback(summary, description);
    const obs: Observable<any> = this._httpClient.post(FeedbackService.FEEDBACK_ENDPOINT, feedback);
    return this._toPromise(obs, message, 'feedback-error');
  }

  /**
   * Builds the feedback object ready for submission to the web-service.
   *
   * @param summary     {string}     Feedback summary
   * @param description {string}     Feedback description
   * @returns           {Feedback}   The feedback object
   */
  private _buildFeedback(summary: string, description: string): Feedback {
    const location: string = window.location ? window.location.href : '';
    const logs: string = Logger.getLogs()
      .map((log: Log) => log.message)
      .join(`<br/>`)
      .slice(-2000);

    return {
      summary,
      description,
      location,
      logs
    };
  }
}
